import styled from 'styled-components/macro';
import Icon from '../Icon';
import {
  white,
  blue,
  blueHover,
  blueSecondaryLight,
  graySecondaryDark,
  grayDisabled,
} from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const StyledPlainButton = styled.button`
  display: flex;
  background: ${({ selected, inverse }) =>
    (inverse && blue) || (selected && blueSecondaryLight) || white};
  border-radius: 30px;
  border: 1px solid ${blue};
  color: ${({ selected, inverse }) =>
    (inverse && white) || (selected && graySecondaryDark) || blue};
  cursor: pointer;
  min-height: 40px;
  height: 50px;
  width: ${({ width }) => width || '140px'};
  align-items: center;
  position: relative;
  ${({ center }) => center && 'margin: 0 auto;'}

  :hover {
    border-color: ${blueHover};
    background: ${({ selected, inverse }) =>
      (inverse && blueHover) || (selected && blueSecondaryLight) || white};
    color: ${({ selected, inverse }) =>
      (inverse && white) || (selected && graySecondaryDark) || blueHover};
  }
  :active {
    color: ${graySecondaryDark};
    background: ${blueSecondaryLight};
  }

  &.disabled,
  &.disabled:hover {
    background-color: ${grayDisabled};
    color: ${white};
    border-color: ${white};
    cursor: not-allowed;
  }

  ${media.desktop`
    height: 50px;
    width: ${({ icon }) => (icon ? '180px' : '60px')};
  `};
`;

export const ContentWrapper = styled.span`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 500)};
  margin: auto;
  ${fontSize(14)};
  letter-spacing: 0.34px;
`;

export const ButtonIcon = styled(Icon)`
  ${fontSize(14)};
  margin-left: 10px;
`;
